export default (Vue) => {
  Vue.directive('btnauth', {
    inserted(el, binding) {
      const guid = binding.arg
      let btnCodeAuth = localStorage.getItem('btnAuthCodeList')
      btnCodeAuth = btnCodeAuth.split(',')
      let isShow = false
      btnCodeAuth.forEach((item) => {
        if (item === guid) {
          isShow = true
        }
      })
      if (!isShow) {
        el.remove()
      }
    }
  })
}
